import type { ListBuilderConfiguration } from '../../types';
import { allInvoicesList } from './lists/all-invoices';
import { currentInvoicesList } from './lists/current-invoices';
import { pastDue1To30List } from './lists/past-due-1-30';
import { pastDue31To60List } from './lists/past-due-31-60';
import { pastDue61To90List } from './lists/past-due-61-90';
import { pastDue90PlusList } from './lists/past-due-90-plus';
import { pastDueInvoicesList } from './lists/past-due-invoices';

/**
 * Invoice list configuration
 * Lists: Last 90D, Past Due, Current, Past Due 1-30, Past Due 31-60, Past Due 61-90, Past Due 90+
 */
export const INVOICE_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		allInvoicesList,
		pastDueInvoicesList,
		currentInvoicesList,
		pastDue1To30List,
		pastDue31To60List,
		pastDue61To90List,
		pastDue90PlusList,
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [20, 50, 100],
	},
	showResetButton: true,
	filters: {
		activeFilters: [
			'invoiceKeywords',
			'invoiceCompany',
			'invoiceDateRange',
			'invoiceDueDateRange',
			'invoiceSalesRep',
			'invoicePaymentStatus',
			'invoiceEmailSent',
		],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/invoices/:id',
			objectLabel: 'Invoice',
			objectTable: 'invoice',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'externalId', fieldLabel: 'External ID' },
				{ fieldName: 'externalId2', fieldLabel: 'External ID 2' },
				{ fieldName: 'date', fieldLabel: 'Date' },
				{ fieldName: 'dueDate', fieldLabel: 'Due Date' },
				{ fieldName: '_fk_client__id', fieldLabel: 'Client ID' },
				{ fieldName: 'fk_company__id', fieldLabel: 'Company ID' },
				{ fieldName: 'clientName', fieldLabel: 'Client Name' },
				{ fieldName: 'clientExternalId', fieldLabel: 'Client External ID' },
				{ fieldName: 'clientExternalId2', fieldLabel: 'Client External ID 2' },
				{ fieldName: 'clientAddress1', fieldLabel: 'Client Address 1' },
				{ fieldName: 'clientAddress2', fieldLabel: 'Client Address 2' },
				{ fieldName: 'clientCity', fieldLabel: 'Client City' },
				{ fieldName: 'clientState', fieldLabel: 'Client State' },
				{ fieldName: 'clientZip', fieldLabel: 'Client Zip' },
				{ fieldName: 'numberOfLines', fieldLabel: 'Number of Lines' },
				{ fieldName: 'tax', fieldLabel: 'Tax' },
				{ fieldName: 'freight', fieldLabel: 'Freight' },
				{ fieldName: 'discount', fieldLabel: 'Discount' },
				{ fieldName: 'subtotal', fieldLabel: 'Subtotal' },
				{ fieldName: 'total', fieldLabel: 'Total' },
				{ fieldName: 'salesRepFirstName', fieldLabel: 'Sales Rep First Name' },
			],
		},
		{
			baseUrl: '/clients/:id',
			objectLabel: 'Client',
			objectTable: 'client',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
			],
		},
	],
	tableSorts: [
		{
			id: 'date-desc',
			name: 'Date (Newest First)',
			fields: [
				{ direction: 'DESC', fieldName: 'date', objectTable: 'invoice' },
			],
			description: 'Sort by invoice date descending',
		},
		{
			id: 'date-asc',
			name: 'Date (Oldest First)',
			fields: [{ direction: 'ASC', fieldName: 'date', objectTable: 'invoice' }],
			description: 'Sort by invoice date ascending',
		},
	],
};
